import React from "react";
import SectionHeader from "@/components/shared/SectionHeader";
import { EISG_IMG } from "@/lib/data";
import { LineChart, Gauge, Cpu, FileBarChart2 } from "lucide-react";
import { useI18n } from "@/lib/i18n";

const ICONS = [Gauge, LineChart, Cpu, FileBarChart2];

const BDIntelligence = () => {
  const { t } = useI18n();
  return (
    <div>
      <section className="relative py-32 lg:py-40 overflow-hidden bg-white border-b border-[#0A192F]/10">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 items-end">
          <div className="lg:col-span-7">
            <div className="overline text-[#0A192F]/60 mb-6">{t("intel.hero.eyebrow")}</div>
            <h1 className="font-bd text-4xl sm:text-5xl lg:text-6xl text-[#0A192F] font-bold tracking-tight leading-[1.02]">
              {t("intel.hero.title.a")} <span className="text-[#F58220]">{t("intel.hero.title.b")}</span>
            </h1>
            <p className="mt-8 text-lg sm:text-xl text-[#0A192F]/75 max-w-2xl leading-relaxed">
              {t("intel.hero.body")}
            </p>
          </div>
          <div className="lg:col-span-5">
            <img src={EISG_IMG.dashboard} alt="Analytics" className="w-full h-[420px] object-cover" />
          </div>
        </div>
      </section>

      <section className="py-24 lg:py-32 bg-[#FAFAFA]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <SectionHeader number={t("intel.platforms.number")} eyebrow={t("intel.platforms.eyebrow")} title={t("intel.platforms.title")} />
          <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-px bg-[#0A192F]/10">
            {ICONS.map((Icon, i) => (
              <div key={i} className="bg-white p-10 lift-card">
                <div className="flex items-start gap-4">
                  <div className="section-num">— {String(i + 1).padStart(2, "0")}</div>
                  <div>
                    <Icon size={28} className="text-[#0A192F] mb-4" />
                    <h3 className="font-bd text-2xl text-[#0A192F] tracking-tight">{t(`intel.platforms.${i}.title`)}</h3>
                    <p className="mt-3 text-[#0A192F]/70 leading-relaxed">{t(`intel.platforms.${i}.desc`)}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 lg:py-32 bg-[#0A192F] text-white grain">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <p className="font-eisg text-3xl sm:text-4xl lg:text-5xl leading-[1.15] tracking-tight max-w-4xl">
            "{t("intel.quote.a")} <span className="text-[#D4AF37] italic">{t("intel.quote.b")}</span>{t("intel.quote.c")}"
          </p>
          <div className="mt-8 overline text-[#D4AF37]">{t("intel.quote.attr")}</div>
        </div>
      </section>
    </div>
  );
};

export default BDIntelligence;
